module.exports = __webpack_public_path__ + "img/whatsapp.a6c873d8.webp";